import {
  post_data,
  removeErrorMessage,
  showErrorMessage,
} from "../helpers/functions";

export default function reset_password_page() {
  if (window.location.href.indexOf("/reset_password") === -1) return;
  const password = document.querySelector(".new_password");
  const confirmPassword = document.querySelector(".repeat_new_password");
  const id = document.querySelector("#uid")?.textContent.trim();
  const token = document.querySelector("#token")?.textContent.trim();
  const changePassword = document.getElementById("change_password");
  const container = document.querySelector(".form-container");

  changePassword.addEventListener("click", async () => {
    if (password.value === "" || confirmPassword.value === "") return showErrorMessage("Field can't be empty."); // prettier-ignore
    if (password.value !== confirmPassword.value)  return showErrorMessage("Passwords must match."); // prettier-ignore
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "reset_forgotten_password",
        id,
        token,
        password: password.value,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    if (response.valid === 0 || response === false) return showErrorMessage(response.msg); // prettier-ignore
    container.innerHTML = "";
    const message = document.createElement("p");
    Object.assign(message, {
      className: "input-container text-center",
      textContent:
        "Your password has been successfully changed. You can now sign in with new password. ",
    });
    const goBack = document.createElement("a");
    Object.assign(goBack, {
      className: "btn btn-primary w-100 mt-4",
      href: "./login",
      textContent: "OK",
    });
    container.append(message);
    container.append(goBack);
  });
  password.addEventListener("focus", removeErrorMessage);
  confirmPassword.addEventListener("focus", removeErrorMessage);
}
